var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.items.length === 0)?_c('span',[_vm._v("-")]):_vm._l((_vm.items),function(item,index){return _c('span',{staticClass:"badge badge-secondary rounded-pill text-capitalize",class:{'mr-2': _vm.items.length > 0 && index !== _vm.items.length - 1}},[_vm._v("\n        "+_vm._s(item.parent_tax.name)+"\n    ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }